// Shared constants for chat message components

export const IMG_URL_RE = /(https?:\/\/[^\s]+\.(?:jpg|jpeg|png|gif|webp|avif|svg)(?:\?[^\s]*)?)/i;

// Tools that produce images — get special rendering (progress card, image grid)
export const GEN_TOOLS = new Set([
  'runModelTool', 'run-model', 'runWorkflowTool', 'run-workflow',
  'multiFormatTool', 'multi-format', 'generateImageTool', 'generate-image',
]);

// Tools that have their own dedicated UI cards (verify-assets, ask-user) — always shown
// Tools in USER_FACING_TOOLS get friendly display names in production mode
export const USER_FACING_TOOLS = {
  'verifyAssetsTool': 'Asset Verification',
  'verify-assets': 'Asset Verification',
  'askUserTool': 'Question',
  'ask-user': 'Question',
  'generateImageTool': 'Image Generation',
  'generate-image': 'Image Generation',
  'generateMarketingCopyTool': 'Marketing Copy',
  'generate-marketing-copy': 'Marketing Copy',
  'runModelTool': 'Image Generation',
  'run-model': 'Image Generation',
  'runWorkflowTool': 'Image Generation',
  'run-workflow': 'Image Generation',
  'multiFormatTool': 'Multi-Format Generation',
  'multi-format': 'Multi-Format Generation',
};

// All tools NOT in USER_FACING_TOOLS are hidden in production mode (shown in dev mode)
export function isHiddenTool(toolName) {
  return !(toolName in USER_FACING_TOOLS);
}

export function getToolDisplayName(toolName) {
  return USER_FACING_TOOLS[toolName] || toolName;
}

export function extractTextContent(content) {
  if (!content) return '';
  if (typeof content === 'string') return content;
  if (Array.isArray(content)) return content.filter(p => p.type === 'text').map(p => p.text).join('');
  return content?.content || content?.parts?.[0]?.text || '';
}
